/* ==========================================================================
   Yachu theme.js
   Shopify cart (Ajax API + Section Rendering), cart drawer, product form,
   color variants + gallery, quantity, accordions, carousels, home hero
   colors, "Make your own set", sticky phone buy bar, Help tabs, menu.
   The gallery, accordion, carousel and buy-bar code is the same code that
   was tested in the design preview.
   ========================================================================== */
(function () {
'use strict';
var ROOT = document.documentElement;
var MONEY_FORMAT = ROOT.getAttribute('data-money-format') || '${{amount}}';
function money(cents) {
  var n = Math.round(cents);
  var whole = n % 100 === 0;
  var amt = whole ? String(n / 100) : (n / 100).toFixed(2);
  amt = amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return MONEY_FORMAT.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt);
}
function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
function $(s, r) { return (r || document).querySelector(s); }
function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

/* ---------------- Cart ---------------- */
var Cart = {
  add: function (items) {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  },
  change: function (key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  },
  refresh: function (open) {
    return fetch(window.location.pathname + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var html = data['cart-drawer'];
      var wrap = document.getElementById('shopify-section-cart-drawer');
      if (html && wrap) {
        var wasOpen = isDrawerOpen();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-cart-drawer');
        wrap.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
        if (wasOpen || open) openDrawer(true);
      }
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('yachu:cart', { detail: cart }));
    });
  }
};
window.YachuCart = Cart;
function isDrawerOpen() { var d = $('[data-cart-drawer]'); return !!(d && d.classList.contains('is-open')); }
function openDrawer(instant) {
  var d = $('[data-cart-drawer]'), b = $('[data-cart-backdrop]');
  if (!d) return;
  d.hidden = false; if (b) b.hidden = false;
  var go = function () { d.classList.add('is-open'); if (b) b.classList.add('is-open'); };
  if (instant) go(); else requestAnimationFrame(go);
  document.body.style.overflow = 'hidden';
  var close = $('[data-cart-close]', d); if (close && !instant) close.focus();
}
function closeDrawer() {
  var d = $('[data-cart-drawer]'), b = $('[data-cart-backdrop]');
  if (!d) return;
  d.classList.remove('is-open'); if (b) b.classList.remove('is-open');
  document.body.style.overflow = '';
  setTimeout(function () { if (!d.classList.contains('is-open')) { d.hidden = true; if (b) b.hidden = true; } }, 280);
}
var onCartPage = !!document.querySelector('[data-cart-page]');
document.addEventListener('click', function (e) {
  var t = e.target;
  var toggle = t.closest('[data-cart-toggle]');
  if (toggle && !onCartPage) { e.preventDefault(); isDrawerOpen() ? closeDrawer() : openDrawer(); return; }
  if (t.closest('[data-cart-close]') || t.closest('[data-cart-backdrop]')) { closeDrawer(); return; }
  var ch = t.closest('[data-cart-change]');
  if (ch) {
    e.preventDefault();
    var line = ch.closest('[data-line]'); if (line) line.style.opacity = '.5';
    Cart.change(ch.getAttribute('data-cart-change'), parseInt(ch.getAttribute('data-qty'), 10) || 0).then(function () {
      if (onCartPage) window.location.reload(); else Cart.refresh(false);
    });
    return;
  }
  var add = t.closest('[data-add-variant]');
  if (add) {
    e.preventDefault(); add.disabled = true;
    Cart.add([{ id: parseInt(add.getAttribute('data-add-variant'), 10), quantity: 1 }]).then(function () {
      if (onCartPage) window.location.reload(); else Cart.refresh(true);
    }).catch(function (err) { add.disabled = false; alert((err && err.description) || 'Could not add that item.'); });
  }
});
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isDrawerOpen()) closeDrawer(); });

/* ---------------- Header: mobile menu + sticky offset ---------------- */
document.addEventListener('click', function (e) {
  var m = e.target.closest('[data-menu-toggle]');
  if (!m) return;
  var nav = $('[data-mobile-nav]'); if (!nav) return;
  nav.hidden = !nav.hidden; m.setAttribute('aria-expanded', String(!nav.hidden));
});

/* ---------------- Accordions / carousels (from the design preview) ---------------- */
function bindAccordions(root) {
  (root || document).querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    if (btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      var open = btn.getAttribute('aria-expanded') === 'true';
      var group = btn.getAttribute('data-accordion-group');
      if (group) {
        document.querySelectorAll('[data-accordion-group="' + group + '"]').forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            var sign = other.querySelector('[data-accordion-sign]');
            if (sign) sign.textContent = '+';
            var op = document.getElementById(other.getAttribute('aria-controls'));
            if (op) op.hidden = true;
          }
        });
      }
      btn.setAttribute('aria-expanded', String(!open));
      var mySign = btn.querySelector('[data-accordion-sign]');
      if (mySign) mySign.textContent = open ? '+' : '−';
      if (panel) panel.hidden = open;
    });
  });
}

function bindCarouselButtons() {
  document.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(function (btn) {
    if (btn.dataset.bound) return;
    btn.dataset.bound = '1';
    var dir = btn.hasAttribute('data-carousel-prev') ? -1 : 1;
    btn.addEventListener('click', function () {
      var scope = btn.closest('section') || btn.closest('.shopify-section') || document;
      var track = scope.querySelector('[data-carousel]');
      if (!track) return;
      var first = track.children[0], step = track.clientWidth * 0.8;
      if (first) { var cw = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0); if (cw > step) step = cw; }
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });
  });
}

/* ============================================================
   Home page
   ============================================================ */


/* ---------------- Product gallery (from the design preview) ---------------- */
function hgRender(root, G, st) {
  var i = Math.min(st.img, G.length - 1);
  root._hg = st;
  root.className = 'pdp-gallery hg-root';
  root.innerHTML = '<div class="hg" style="--n:' + G.length + '">' +
    '<div class="hg__thumbs" role="tablist" aria-label="Product photos">' + G.map(function (g, idx) {
      return '<button type="button" class="hg__thumb' + (idx === i ? ' is-active' : '') + '" data-hg-go="' + idx + '" aria-label="Photo ' + (idx + 1) + ': ' + esc(g.alt) + '"><img src="' + g.src + '" alt=""></button>';
    }).join('') + '</div>' +
    '<div class="hg__stage">' +
    '<div class="hg__track" data-hg-track>' + G.map(function (g, idx) {
      var cap = g.cap ? '<div class="pdp-gallery__cap"><span>' + esc(g.cap.l) + '</span><span>' + esc(g.cap.r || '') + '</span></div>' : '';
      return '<figure class="hg__slide"' + (g.bg ? ' style="background:' + g.bg + '"' : '') + '><img src="' + g.src + '" alt="' + esc(g.alt) + '" style="object-fit:' + g.fit + ';object-position:' + (g.pos || '50% 50%') + '"' + (idx ? ' loading="lazy"' : '') + '>' + cap + '</figure>';
    }).join('') + '</div>' +
    '<span class="hg__count" data-hg-count>' + (i + 1) + ' / ' + G.length + '</span>' +
    '<button type="button" class="hg__arrow hg__arrow--prev" data-hg-step="-1" aria-label="Previous photo">‹</button>' +
    '<button type="button" class="hg__arrow hg__arrow--next" data-hg-step="1" aria-label="Next photo">›</button>' +
    '</div>' +
    '<div class="hg__dots">' + G.map(function (g, idx) { return '<button type="button" class="hg__dot' + (idx === i ? ' is-active' : '') + '" data-hg-go="' + idx + '" aria-label="Go to photo ' + (idx + 1) + '"></button>'; }).join('') + '</div>' +
    '</div>';
  var track = root.querySelector('[data-hg-track]');
  if (i) hgAlign(track, i);
  hgSync(root, i, G.length);
  var t;
  track.addEventListener('scroll', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      var idx = hgIndex(track);
      if (idx !== st.img) { st.img = idx; hgSync(root, idx, G.length); }
    }, 60);
  }, { passive: true });
}
function hgBind(root) {
  if (!root || root._hgBound) return; root._hgBound = true;
  root.addEventListener('keydown', function (e) {
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && e.target.closest('.hg')) { e.preventDefault(); hgGo(root, root._hg.img + (e.key === 'ArrowRight' ? 1 : -1)); }
  });
  root.addEventListener('click', function (e) {
    var go = e.target.closest('[data-hg-go]');
    if (go) { hgGo(root, parseInt(go.getAttribute('data-hg-go'), 10)); return; }
    var st = e.target.closest('[data-hg-step]');
    if (st) hgGo(root, root._hg.img + parseInt(st.getAttribute('data-hg-step'), 10));
  });
}
function hgSync(root, idx, n) {
  root.querySelectorAll('[data-hg-go]').forEach(function (b) { var on = +b.getAttribute('data-hg-go') === idx; b.classList.toggle('is-active', on); if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
  var c = root.querySelector('[data-hg-count]'); if (c) c.textContent = (idx + 1) + ' / ' + n;
  var pv = root.querySelector('[data-hg-step="-1"]'), nx = root.querySelector('[data-hg-step="1"]');
  if (pv) pv.disabled = idx <= 0; if (nx) nx.disabled = idx >= n - 1;
}
function hgOffset(track, idx) { var s = track.children; return s[idx].offsetLeft - s[0].offsetLeft; }
function hgIndex(track) {
  var n = track.children.length, max = track.scrollWidth - track.clientWidth;
  if (max <= 2) return 0;
  if (track.scrollLeft >= max - 2) return n - 1;
  var best = 0, d = Infinity;
  for (var k = 0; k < n; k++) { var dd = Math.abs(hgOffset(track, k) - track.scrollLeft); if (dd < d) { d = dd; best = k; } }
  return best;
}
function hgAlign(track, idx) { track.style.scrollBehavior = 'auto'; track.scrollLeft = hgOffset(track, idx); track.style.scrollBehavior = ''; }
function hgGo(root, idx) {
  var track = root.querySelector('[data-hg-track]'); if (!track) return;
  var n = track.children.length; idx = Math.max(0, Math.min(n - 1, idx));
  root._hg.img = idx; track.scrollTo({ left: hgOffset(track, idx) }); hgSync(root, idx, n);
}
(function () {
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { document.querySelectorAll('.hg-root').forEach(function (r) { var t = r.querySelector('[data-hg-track]'); if (t && t.offsetParent && r._hg) hgAlign(t, r._hg.img); }); }, 120);
  });
})();


/* ---------------- Product page ---------------- */
function readJSON(sel, root) { var el = $(sel, root); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
function colorOf(v) { return v ? v.option1 : null; }
function galleryFor(data, color, fallbackTitle) {
  if (!data) return [];
  if (data._media) {
    var colors = {};
    data._media.forEach(function (m) { (m.alt.match(/#[\w-]+/g) || []).forEach(function (t) { colors[t.slice(1).toLowerCase()] = 1; }); });
    var c = (color || '').toLowerCase();
    return data._media.filter(function (m) {
      var tags = (m.alt.match(/#[\w-]+/g) || []).map(function (t) { return t.slice(1).toLowerCase(); });
      var tagColors = tags.filter(function (t) { return t !== 'contain'; });
      return !tagColors.length || tagColors.indexOf(c) > -1;
    }).map(function (m) {
      var tags = (m.alt.match(/#[\w-]+/g) || []).map(function (t) { return t.slice(1).toLowerCase(); });
      return { src: m.src, fit: tags.indexOf('contain') > -1 ? 'contain' : 'cover', alt: m.alt.replace(/#[\w-]+/g, '').trim() || fallbackTitle };
    });
  }
  return data[color] || data._all || data[Object.keys(data)[0]] || [];
}
function initProduct(root) {
  if (!root || root._init) return; root._init = true;
  var gal = $('[data-product-gallery]', root);
  var data = readJSON('[data-gallery-json]', root);
  var variants = readJSON('[data-variants-json]', root) || [];
  var form = $('[data-atc-form]', root);
  var idInput = form ? $('[data-variant-input]', form) : null;
  var qtyInput = form ? $('[data-qty-input]', form) : null;
  var state = { img: 0, qty: 1 };
  var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];
  var title = ($('h1', root) || {}).textContent || '';
  function render() {
    var G = galleryFor(data, colorOf(current), title);
    if (gal && G.length) { hgRender(gal, G, state); hgBind(gal); }
    var first = G[0];
    var bImg = $('[data-pdp-buybar-img]'); if (bImg && first) bImg.src = first.src;
  }
  function priceUI() {
    if (!current) return;
    var p = $('[data-product-price]', root); if (p) p.textContent = money(current.price);
    var tot = money(current.price * state.qty);
    var t = $('[data-atc-total]', root); if (t) t.textContent = tot;
    var bt = $('[data-pdp-buybar-total]'); if (bt) bt.textContent = tot;
    var btn = $('[data-atc-submit]', root);
    if (btn) { btn.disabled = !current.available; var l = $('[data-label]', btn); if (l) l.textContent = current.available ? 'Add to cart' : 'Sold out'; }
    var bb = $('[data-pdp-buybar-add]'); if (bb) bb.disabled = !current.available;
    var meta = $('[data-pdp-buybar-meta]');
    if (meta) { var w = current.weight ? Math.round(current.weight) + ' g' : ''; meta.textContent = [current.option1 && current.option1 !== 'Default Title' ? current.option1 : '', w].filter(Boolean).join(' · '); }
  }
  // color swatches
  $$('[data-color-swatches] .swatch', root).forEach(function (sw) {
    sw.addEventListener('click', function () {
      var c = sw.getAttribute('data-color');
      var v = variants.filter(function (x) { return x.option1 === c && x.available; })[0] || variants.filter(function (x) { return x.option1 === c; })[0];
      if (!v) return;
      current = v; if (idInput) idInput.value = v.id;
      $$('[data-color-swatches] .swatch', root).forEach(function (b) { var on = b === sw; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
      var n = $('[data-color-name]', root); if (n) n.textContent = c;
      state.img = 0; render(); priceUI();
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); u.searchParams.delete('color'); history.replaceState(null, '', u.toString()); } catch (e) {}
    });
  });
  // ?color=orange from the homepage
  try {
    var qc = new URL(window.location.href).searchParams.get('color');
    if (qc) { var sw0 = $$('[data-color-swatches] .swatch', root).filter(function (b) { return b.getAttribute('data-color').toLowerCase() === qc.toLowerCase(); })[0]; if (sw0) sw0.click(); }
  } catch (e) {}
  // quantity
  $$('[data-qty-stepper] [data-qty-dir]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      state.qty = Math.max(1, state.qty + parseInt(b.getAttribute('data-qty-dir'), 10));
      var v = $('[data-qty-value]', root); if (v) v.textContent = state.qty;
      if (qtyInput) qtyInput.value = state.qty;
      priceUI();
    });
  });
  // add to cart
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = $('[data-atc-submit]', form); var label = btn ? $('[data-label]', btn) : null;
    if (btn) btn.disabled = true; if (label) label.textContent = 'Adding…';
    Cart.add([{ id: parseInt(idInput.value, 10), quantity: state.qty }]).then(function () {
      if (label) label.textContent = 'Added ✓';
      setTimeout(function () { if (btn) btn.disabled = false; if (label) label.textContent = 'Add to cart'; }, 1400);
      return Cart.refresh(true);
    }).catch(function (err) {
      if (btn) btn.disabled = false; if (label) label.textContent = 'Add to cart';
      alert((err && err.description) || 'Could not add that item to your cart.');
    });
  });
  var bbAdd = $('[data-pdp-buybar-add]');
  if (bbAdd) bbAdd.addEventListener('click', function () { var b = $('[data-atc-submit]', root); if (b) b.click(); });
  render(); priceUI();
}

/* ---------------- Sticky phone buy bar (from the design preview) ---------------- */
function syncHeaderVar() { var hd = document.querySelector('.site-header-wrap'); if (hd) document.documentElement.style.setProperty('--yc-header', Math.round(hd.getBoundingClientRect().height) + 'px'); }
window.addEventListener('resize', syncHeaderVar); document.addEventListener('DOMContentLoaded', syncHeaderVar);
function syncBuybar() {
  var on = false;
  if (document.body.getAttribute('data-pdp-active') === '1' && window.innerWidth < 900) {
    var main = document.querySelector('[data-product-root] [data-atc-submit]');
    var foot = document.querySelector('.site-footer');
    var past = main ? main.getBoundingClientRect().bottom < 0 : false;
    var footIn = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
    if (main && ioState.el === main && ioState.known) { if (!ioState.mainIn && ioState.seenMain) past = true; if (ioState.mainIn) past = false; }
    if (ioState.footIn) footIn = true;
    on = past && !footIn;
  }
  document.body.classList.toggle('buybar-on', on);
  var bar = document.querySelector('[data-pdp-buybar]'); if (bar) bar.setAttribute('aria-hidden', String(!on));
}
/* Works whether the page scrolls the window or an inner container (e.g. an embedded preview):
   capture-phase scroll listener catches scrolling on any element, and an IntersectionObserver
   re-checks whenever the main button or the footer moves in or out of view. */
var syncQueued = false;
function queueBuybar() { if (syncQueued) return; syncQueued = true; requestAnimationFrame(function () { syncQueued = false; syncBuybar(); }); }
document.addEventListener('scroll', queueBuybar, { capture: true, passive: true });
window.addEventListener('resize', queueBuybar);
var ioState = { el: null, known: false, mainIn: false, seenMain: false, footIn: false };
var buybarIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
  entries.forEach(function (en) {
    if (en.target.classList.contains('site-footer')) ioState.footIn = en.isIntersecting;
    else if (en.target === ioState.el) { ioState.known = true; ioState.mainIn = en.isIntersecting; if (en.isIntersecting) ioState.seenMain = true; }
  });
  syncBuybar();
}, { threshold: [0] }) : null;
function observeBuybarTargets() {
  if (!buybarIO) return;
  buybarIO.disconnect();
  var main = document.querySelector('[data-product-root] [data-atc-submit]');
  ioState = { el: main, known: false, mainIn: false, seenMain: false, footIn: false };
  if (main) buybarIO.observe(main);
  var foot = document.querySelector('.site-footer'); if (foot) buybarIO.observe(foot);
}
document.addEventListener('DOMContentLoaded', function () { observeBuybarTargets(); syncBuybar(); });
setInterval(function () { if (document.body.getAttribute('data-pdp-active') === '1') syncBuybar(); }, 800);


/* ---------------- Home hero colors ---------------- */
function initHomeHero() {
  var sws = $$('[data-home-swatches] .swatch'); if (!sws.length) return;
  sws.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sws.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      var d = btn.dataset;
      var n = $('[data-home-color-name]'); if (n) n.textContent = d.name;
      var img = $('[data-home-hero-img]');
      if (img) { img.removeAttribute('srcset'); img.src = d.img; img.alt = d.alt; img.style.objectPosition = d.pos; img.style.setProperty('--pos-m', d.posM || d.pos); }
      var l = $('[data-home-photo-l]'); if (l) l.textContent = d.l;
      var r = $('[data-home-photo-r]'); if (r) r.textContent = d.r;
      var hand = $('[data-home-ledger-img]'); if (hand && d.hand) hand.src = d.hand;
      var cut = $('[data-home-ledger-pouch]'); if (cut && d.cut) cut.src = d.cut;
      $$('[data-home-see-hammock],[data-home-hammock-link]').forEach(function (a) { a.setAttribute('href', d.url); });
    });
  });
}

/* ---------------- Make your own set ---------------- */
function initSetBuilder() {
  var root = $('[data-set-builder]'); if (!root) return;
  var rows = $$('[data-pack-item]', root);
  function grams(n) { return n >= 1000 ? (n / 1000).toFixed(2).replace(/0$/, '') + ' kg' : Math.round(n) + ' g'; }
  function update() {
    var on = rows.filter(function (r) { return r.getAttribute('aria-pressed') === 'true'; });
    var w = on.reduce(function (s, r) { return s + (parseFloat(r.dataset.grams) || 0); }, 0);
    var sub = on.reduce(function (s, r) { return s + (parseInt(r.dataset.price, 10) || 0); }, 0);
    var rate = on.length >= 3 ? 0.2 : on.length === 2 ? 0.1 : 0;
    var disc = Math.round(sub * rate);
    var we = $('[data-pack-weight]', root); if (we) we.textContent = w ? grams(w) : '–';
    var ce = $('[data-pack-count]', root); if (ce) ce.textContent = on.length === 1 ? '1 piece' : on.length + ' pieces';
    var dr = $('[data-pack-disc-row]', root); if (dr) dr.hidden = !rate;
    var dl = $('[data-pack-disc-label]', root); if (dl) dl.textContent = on.length >= 3 ? '20% off' : '10% off';
    var dd = $('[data-pack-disc]', root); if (dd) dd.textContent = '−' + money(disc);
    var tt = $('[data-pack-total]', root); if (tt) tt.textContent = money(sub - disc);
    var add = $('[data-pack-add]', root); if (add) add.disabled = !on.length;
    var lbl = add ? $('[data-label]', add) : null; if (lbl) lbl.textContent = on.length ? 'Add to cart' : 'Pick at least one piece';
  }
  rows.forEach(function (r) {
    r.addEventListener('click', function () {
      var on = r.getAttribute('aria-pressed') !== 'true';
      r.setAttribute('aria-pressed', String(on));
      var box = $('.checklist-row__box', r); if (box) { box.classList.toggle('is-on', on); box.textContent = on ? '✓' : ''; }
      update();
    });
  });
  var add = $('[data-pack-add]', root);
  if (add) add.addEventListener('click', function () {
    var items = rows.filter(function (r) { return r.getAttribute('aria-pressed') === 'true'; }).map(function (r) { return { id: parseInt(r.getAttribute('data-pack-item'), 10), quantity: 1 }; });
    if (!items.length) return;
    add.disabled = true;
    Cart.add(items).then(function () { add.disabled = false; return Cart.refresh(true); }).catch(function (err) { add.disabled = false; alert((err && err.description) || 'Could not add those items.'); });
  });
  update();
}

/* ---------------- Help tabs ---------------- */
function initHelp() {
  var tabs = $$('[data-help-tabs] [data-tab]'); if (!tabs.length) return;
  var titles = {};
  tabs.forEach(function (b) { titles[b.getAttribute('data-tab')] = b.textContent.trim(); });
  function select(tab, push) {
    if (!titles[tab]) tab = tabs[0].getAttribute('data-tab');
    tabs.forEach(function (b) { var on = b.getAttribute('data-tab') === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
    $$('[data-tab-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== tab; });
    var t = $('[data-help-title]'); if (t) t.textContent = titles[tab].replace('&', '&');
    if (push) { try { var u = new URL(window.location.href); u.searchParams.set('tab', tab); history.replaceState(null, '', u.toString()); } catch (e) {} }
  }
  tabs.forEach(function (b) { b.addEventListener('click', function () { select(b.getAttribute('data-tab'), true); }); });
  var url = new URL(window.location.href);
  var tab = url.searchParams.get('tab');
  if (url.searchParams.get('contact_posted') || url.hash === '#ContactForm' || $('#ContactForm .form-status')) tab = 'contact';
  select(tab || tabs[0].getAttribute('data-tab'), false);
  // in-page links to other tabs
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="/pages/help?tab="]'); if (!a) return;
    var m = a.getAttribute('href').match(/tab=([\w-]+)/);
    if (m && window.location.pathname.indexOf('/pages/help') > -1) { e.preventDefault(); select(m[1], true); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  });
}

/* ---------------- Init ---------------- */
function init() {
  bindAccordions(); bindCarouselButtons();
  $$('[data-product-root]').forEach(initProduct);
  initHomeHero(); initSetBuilder(); initHelp();
  syncHeaderVar();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', function () { $$('[data-product-root]').forEach(function (r) { r._init = false; initProduct(r); }); bindAccordions(); bindCarouselButtons(); initHomeHero(); initSetBuilder(); initHelp(); });
})();
